import i18n from 'i18next'

export const getErrorMessage = (errorCode: string): string => {
  const errorKey = `errors.${errorCode}`
  const translated = i18n.t(errorKey)

  if (translated === errorKey) {
    return i18n.t('errors.UNKNOWN_ERROR_CODE')
  }

  return translated
}
